import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import "./Home.css";

const heroSlides = [
    {
        tag: "Kampala - Est du Congo",
        title: "Vos colis voyagent avec precision, vitesse et suivi.",
        description: "La Victoire Express relie Kampala, Uvira, Bukavu, Kalemi, Lubumbashi, Moba et plusieurs autres destinations avec une organisation fiable.",
        image: "/img/pages/about/1.png",
    },
    {
        tag: "Expedition de colis",
        title: "Une agence proche de vos marchandises et de vos delais.",
        description: "Enregistrement clair, manutention soignee et equipe disponible pour accompagner chaque expedition jusqu'a destination.",
        image: "/img/logo2.png",
    },
    {
        tag: "Transport regional",
        title: "Des trajets solides pour connecter vos activites.",
        description: "Un reseau pense pour les commercants, familles, entreprises et voyageurs qui expedient regulierement entre les villes.",
        image: "/img/logo1.png",
    },
];

const destinations = ["Kampala", "Uvira", "Bukavu", "Kalemi", "Lubumbashi", "Moba"];

const whatsappNumber = "243895817994";
const whatsappMessage = encodeURIComponent("https://lavictoire-express.com\n\n\n Bonjour La Victoire Express, je souhaite avoir des informations pour expedier un colis.");
const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

const services = [
    {
        icon: "fa-cube",
        title: "Colis standards",
        text: "Depot rapide, etiquette claire et prise en charge organisee pour vos envois quotidiens.",
    },
    {
        icon: "fa-truck",
        title: "Marchandises",
        text: "Solution adaptee aux volumes moyens, avec depart planifie et reception en agence.",
    },
    {
        icon: "fa-shield",
        title: "Suivi & securite",
        text: "Controle a chaque etape, informations disponibles et traitement attentif des colis sensibles.",
    },
];

const parcelTypes = [
    "Documents et enveloppes",
    "Pieces de rechange",
    "Marchandises commerciales",
    "Effets personnels",
    "Petits appareils",
    "Colis familiaux",
];

const advantages = [
    {
        value: "01",
        title: "Depart organise",
        text: "Chaque colis est identifie avant chargement pour garder une trace claire du trajet.",
    },
    {
        value: "02",
        title: "Equipe disponible",
        text: "Nos agents accompagnent les clients pour le depot, le suivi et la recuperation.",
    },
    {
        value: "03",
        title: "Tarifs accessibles",
        text: "Les prix sont adaptes aux particuliers, commercants et entreprises regulieres.",
    },
    {
        value: "04",
        title: "Reception controlee",
        text: "La remise se fait en agence ou selon les modalites confirmees avec le client.",
    },
];

const steps = [
    "Depot du colis en agence",
    "Verification et enregistrement",
    "Chargement vers la destination",
    "Notification et retrait",
];

const testimonials = [
    {
        name: "Client commercant",
        city: "Kampala - Bukavu",
        text: "J'expedie mes colis chaque semaine. Le service est rapide et l'equipe donne des informations claires.",
    },
    {
        name: "Cliente particuliere",
        city: "Uvira - Lubumbashi",
        text: "Mes effets personnels sont arrives en bon etat. J'ai apprecie l'accueil et le suivi.",
    },
    {
        name: "Entreprise partenaire",
        city: "Kampala - Kalemi",
        text: "La Victoire Express nous aide a garder nos livraisons regulieres sur plusieurs axes.",
    },
];

const faqs = [
    {
        question: "Quelles destinations sont disponibles ?",
        answer: "Nous couvrons notamment Kampala, Uvira, Bukavu, Kalemi, Lubumbashi, Moba et les axes proches selon les departs planifies.",
    },
    {
        question: "Quels colis peut-on envoyer ?",
        answer: "Vous pouvez envoyer des documents, pieces de rechange, effets personnels et marchandises commerciales autorisees.",
    },
    {
        question: "Comment connaitre le prix ?",
        answer: "Le tarif depend du poids, du volume, de la destination et du niveau de prise en charge souhaite.",
    },
];

class Home extends Component {

    componentDidMount() {
        this.refreshToken()
        var country = localStorage.getItem("country") ? JSON.parse(localStorage.getItem("country")) : {};

        if (!country.country)
            this.datacountryIp();

        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }

    async refreshToken() {
        try {
            var token = await axios.get("token");
            if (token.status === 200) {
                var user = (token.data.data);
                localStorage.setItem("user", JSON.stringify(user));
            }
            else if (token.status === 401) {
                axios.delete("logout").then(() => { console.log("disconnect") }).catch(() => { console.log("error") });
                window.localStorage.clear();
            }
        } catch (error) {
            axios.delete("logout").then(() => { console.log("disconnect") }).catch(() => { console.log("error") });
            window.localStorage.clear();
        }
    }

    async datacountryIp() {
        try {
            var ip = await axios("https://httpbin.org/ip");
            if (ip.status === 200) {
                var country = await axios.get("country/" + ip.data.origin);
                if (country.status === 200) {
                    localStorage.setItem("country", JSON.stringify(country.data));
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    render() {
        const slideProps = {
            duration: 4200,
            transitionDuration: 650,
            infinite: true,
            indicators: true,
            arrows: false,
            pauseOnHover: true,
        };

        return (
            <div className="dashboard__content bg-light-2 home-page">
                <section className="home-hero">
                    <div className="home-hero__glow home-hero__glow--one"></div>
                    <div className="home-hero__glow home-hero__glow--two"></div>

                    <div className="container home-hero__container">
                        <div className="home-hero__content">
                            <div className="home-kicker">
                                <span></span>
                                Agence d'expedition de colis
                            </div>
                            <h1>La Victoire Express</h1>
                            <p>
                                Transport fiable des colis entre Kampala, Uvira, Bukavu, Kalemi,
                                Lubumbashi, Moba et les axes voisins.
                            </p>

                            <div className="home-hero__actions">
                                <a href={whatsappUrl} target="_blank" rel="noreferrer" className="home-btn home-btn--primary">
                                    Demander un tarif <i className="fa fa-long-arrow-right"></i>
                                </a>
                                <Link to="/login" className="home-btn home-btn--ghost">
                                    Suivre mes expeditions
                                </Link>
                            </div>

                            <div className="home-stats">
                                <div>
                                    <strong>6+</strong>
                                    <span>Destinations actives</span>
                                </div>
                                <div>
                                    <strong>24/7</strong>
                                    <span>Assistance client</span>
                                </div>
                                <div>
                                    <strong>100%</strong>
                                    <span>Reception en agence</span>
                                </div>
                            </div>
                        </div>

                        <div className="home-hero__slider">
                            <Slide {...slideProps}>
                                {heroSlides.map((slide) => (
                                    <div className="home-slide" key={slide.title}>
                                        <div className="home-slide__media">
                                            <img src={slide.image} alt={slide.tag} />
                                        </div>
                                        <div className="home-slide__body">
                                            <span>{slide.tag}</span>
                                            <h2>{slide.title}</h2>
                                            <p>{slide.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </Slide>
                        </div>
                    </div>
                </section>

                <section className="home-strip">
                    <div className="container">
                        <div className="home-strip__track">
                            {destinations.map((destination) => (
                                <div className="home-destination" key={destination}>
                                    <i className="fa fa-map-marker"></i>
                                    {destination}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="home-section">
                    <div className="container">
                        <div className="home-section__heading">
                            <span>Nos services</span>
                            <h2>Une expedition simple, claire et bien suivie.</h2>
                        </div>

                        <div className="home-service-grid">
                            {services.map((service, index) => (
                                <div className="home-service-card" style={{ animationDelay: `${index * 120}ms` }} key={service.title}>
                                    <div className="home-service-card__icon">
                                        <i className={`fa ${service.icon}`}></i>
                                    </div>
                                    <h3>{service.title}</h3>
                                    <p>{service.text}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="home-about">
                    <div className="container home-about__grid">
                        <div className="home-about__media">
                            <img src="/img/logo.png" alt="La Victoire Express" />
                        </div>
                        <div className="home-about__copy">
                            <span className="home-label">Qui sommes-nous ?</span>
                            <h2>Une agence creee pour faciliter les echanges entre Kampala et les villes du Congo.</h2>
                            <p>
                                La Victoire Express accompagne les commercants, familles, voyageurs
                                et entreprises qui veulent expedier des colis avec plus de clarte.
                                Notre mission est simple: recevoir, organiser, transporter et remettre
                                vos colis dans les meilleures conditions possibles.
                            </p>
                            <div className="home-parcel-list">
                                {parcelTypes.map((type) => (
                                    <span key={type}><i className="fa fa-check"></i>{type}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="home-route-section">
                    <div className="container home-route-grid">
                        <div className="home-route-copy">
                            <span className="home-label">Couloir logistique</span>
                            <h2>Kampala vers le Congo, avec des points de relais clairs.</h2>
                            <p>
                                Notre equipe organise les departs, les arrivages et la remise des
                                colis pour reduire les pertes de temps et garder vos clients informes.
                            </p>
                            <a href={whatsappUrl} target="_blank" rel="noreferrer" className="home-btn home-btn--primary home-btn--dark">
                                Contacter une agence
                            </a>
                        </div>

                        <div className="home-route-map">
                            {destinations.map((destination, index) => (
                                <div className="home-route-stop" key={destination}>
                                    <span>{index + 1}</span>
                                    <strong>{destination}</strong>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="home-section home-section--steps">
                    <div className="container">
                        <div className="home-section__heading home-section__heading--center">
                            <span>Comment ca marche</span>
                            <h2>Quatre etapes pour envoyer votre colis.</h2>
                        </div>

                        <div className="home-steps">
                            {steps.map((step, index) => (
                                <div className="home-step" key={step}>
                                    <div>{index + 1}</div>
                                    <p>{step}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="home-advantages">
                    <div className="container">
                        <div className="home-section__heading">
                            <span>Pourquoi nous choisir</span>
                            <h2>Un service pense pour les colis importants.</h2>
                        </div>
                        <div className="home-advantages__grid">
                            {advantages.map((item) => (
                                <div className="home-advantage" key={item.title}>
                                    <strong>{item.value}</strong>
                                    <h3>{item.title}</h3>
                                    <p>{item.text}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="home-testimonials">
                    <div className="container">
                        <div className="home-section__heading home-section__heading--center">
                            <span>Temoignages</span>
                            <h2>Ils nous confient leurs expeditions.</h2>
                        </div>
                        <div className="home-testimonials__grid">
                            {testimonials.map((testimonial) => (
                                <div className="home-testimonial" key={testimonial.name}>
                                    <i className="fa fa-quote-left"></i>
                                    <p>{testimonial.text}</p>
                                    <div>
                                        <strong>{testimonial.name}</strong>
                                        <span>{testimonial.city}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="home-faq">
                    <div className="container home-faq__grid">
                        <div>
                            <span className="home-label">Informations utiles</span>
                            <h2>Avant de deposer votre colis.</h2>
                            <p>
                                Preparez votre colis avec le nom du destinataire, son telephone,
                                la ville de destination et une description simple du contenu.
                            </p>
                        </div>
                        <div className="home-faq__items">
                            {faqs.map((faq) => (
                                <div className="home-faq__item" key={faq.question}>
                                    <h3>{faq.question}</h3>
                                    <p>{faq.answer}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="home-cta">
                    <div className="container home-cta__inner">
                        <div>
                            <span className="home-label">Besoin d'expedier aujourd'hui ?</span>
                            <h2>Parlez-nous de votre colis et de sa destination.</h2>
                        </div>
                        <a href={whatsappUrl} target="_blank" rel="noreferrer" className="home-btn home-btn--primary">
                            Obtenir une assistance
                        </a>
                    </div>
                </section>
            </div>
        )
    }
}

export default Home;
